export const blockIconsHardwareTv = (
	<span className='material-symbols-outlined'>tv</span>
);
